import {Header} from "semantic-ui-react";

export default function InviteText(props: {text: string}){

    return(
        <Header as='h3' color='black' textAlign='left'>
         {props.text}
        </Header>
    )
}